<!-- auction-dashboard-bidder.component.html -->
<!-- auction-dashboard-bidder.component.html -->
<section class="auction-ledger mb-3">
  <div class="container-fluid">
    <div class="auction-ledger__panel">
      <div class="auction-ledger__header">
        <span class="auction-ledger__eyebrow">Live Lot</span>
        <h4 class="auction-ledger__title">Bidders</h4>
      </div>

      <div class="auction-ledger__body">
        <div class="auction-ledger__grid">
          <div [ngClass]="
              winnerList.length
                ? 'auction-ledger__main auction-ledger__main--split'
                : 'auction-ledger__main'
            ">
            <app-live-auction></app-live-auction>
          </div>

          <aside class="auction-ledger__winners" *ngIf="winnerList.length">
            <h3 class="auction-ledger__winners-title">
              <span class="auction-ledger__winners-mark">✦</span>
              Winners Ledger
            </h3>

            <div class="auction-ledger__scroll">
              <ul class="auction-ledger__list">
                <li class="auction-ledger__entry" *ngFor="let auctionItem of winnerList; let i = index">
                  <div [routerLink]="['/auction-details', auctionItem['auction_id']]"
                    routerLinkActive="router-link-active" class="auction-ledger__link" role="link" tabindex="0">
                    <span class="auction-ledger__paddle" [class.auction-ledger__paddle--top]="i < 3">{{ i + 1 }}</span>

                    <span class="auction-ledger__avatar">
                      <img src="{{ env }}assets/img/user-placeholder.png" alt="" class="auction-ledger__avatar-img" />
                    </span>

                    <span class="auction-ledger__info">
                      <span class="auction-ledger__name">
                        {{ auctionItem?.["user_details"]?.['first_name'] + ' ' +
                        (auctionItem?.["user_details"]?.['last_name'] ? auctionItem?.["user_details"]?.['last_name'] :
                        '') }}
                      </span>
                      <span class="auction-ledger__bid">
                        <span class="auction-ledger__bid-label">Winning bid</span>
                        <span class="auction-ledger__bid-amount">{{ auctionItem["winning_bid_amount"] | number: "1.0-2"
                          }}</span>
                      </span>
                    </span>
                  </div>
                </li>
              </ul>
            </div>
          </aside>
        </div>
      </div>
    </div>
  </div>

  <app-loader *ngIf="loading"></app-loader>
</section>

<!-- <section class="auction-dashboard-charts">
  <div class="container-fluid">
    <div class="card auction-content-main m-0">
      <div class="auction-content-header p-4">
        <h4 class="fs-lg text-uppercase color-ashen-med">PRODUCT POPULARITY</h4>
      </div>
      <div class="auction-content-body px-4 pb-4 pt-2">
        <div class="row mx-n2 mb-4">
          <div class="col-sm-4 col-md-5 px-2">
            <form action="" class="credential4 popularity-filter">
              <div class="form-group">
                <select name="popularity" class="credential4__select form-control">
                  <option value="Top">Top</option>
                </select>
              </div>
            </form>
          </div>

          <div class="col-sm-8 col-md-7 px-2">
            <form action="" class="credential4 chart-filter-form">
              <div class="row mx-n2">
                <div class="col-md-6 px-2">
                  <div class="form-group mb-md-0">
                    <div class="credential4__input-group">
                      <span class="credential4__icon">
                        <img src="{{ env }}assets/img/sidebar/icons8-calendar.svg" alt="" />
                      </span>
                      <input type="text" name="dateRange" id="auction-bids-dateRange"
                        class="credential4__icon-input form-control" placeholder="From - To" [bsConfig]="{
                          rangeInputFormat: 'DD MMM YYYY',
                          dateInputFormat: 'DD MMM YYYY'
                        }" bsDaterangepicker readonly />
                    </div>
                  </div>
                </div>
                <div class="col-md-6 px-2">
                  <div class="input-group credential4__input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <i class="las la-clock ion-2x color-dark"></i>
                      </span>
                    </div>
                    <input type="text" name="time_start" id="auction-bids-timeStart"
                      class="credential4__input form-control" placeholder="From" [ngxTimepicker]="bidTimeStart"
                      readonly />
                    <input type="text" name="time_end" id="auction-bids-timeEnd" class="credential4__input form-control"
                      placeholder="To" [ngxTimepicker]="bidTimeEnd" readonly />
                  </div>
                  <ngx-material-timepicker #bidTimeStart></ngx-material-timepicker>
                  <ngx-material-timepicker #bidTimeEnd></ngx-material-timepicker>
                </div>
              </div>
            </form>
          </div>
        </div>

        <div class="row mx-n2">
          <div class="col-md-6 px-2">
            <div class="auction-dashboard-chart mb-3 mb-md-0">
              <canvas baseChart [datasets]="doughnutChartData" [labels]="doughnutChartLabels"
                [chartType]="doughnutChartType">
              </canvas>
            </div>
          </div>
          <div class="col-md-6 px-2">
            <div class="auction-dashboard-chart">
              <canvas baseChart [datasets]="barChartData" [labels]="barChartLabels" [options]="barChartOptions"
                [legend]="true" [chartType]="barChartType">
              </canvas>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section> -->